module.exports = function throttleUntilCompleteFactory() {
  // Ensures that promisified functions run in serial.
  // Perhaps this module should be called "serialize," but that seems too generic.
  //
  // @memberof OTHelpers
  // @private
  //
  // @return The throttled function.
  //
  return function throttleUntilComplete(fn) {
    // We start our queue with a resolved promise. We do this
    // because we want queue to be thenable, but we also want
    // it to execute the first element of the queue immediately.
    let queue = null;

    return (...args) => {
      const promiseAndRelease = {};

      if (!queue) {
        queue = Promise.resolve();
      }

      // execute our function with args when the previous
      // steps/releases have finished.
      promiseAndRelease.promise = queue.then(() => fn(...args));

      const releasePromise = new Promise((resolve) => {
        promiseAndRelease.release = resolve;
      });

      let item;
      function clean() {
        if (queue === item) {
          queue = null;
        }
      }

      item = queue.then(() => Promise.race([
        promiseAndRelease.promise,
        releasePromise,
      ])).then(clean, clean);
      queue = item;

      return promiseAndRelease;
    };
  };
};



// WEBPACK FOOTER //
// ./src/js/helpers/throttle_until_complete.js